import {Component} from '@angular/core';
@Component({
  selector: 'app-flights-search',
  templateUrl: './flights-search.component.html'
})
export class FlightsSearchComponent {
  constructor() {
    console.log('User Name Mobitrix-Web');
  }
}
